var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 102,
    viewBox: "0 0 82 102",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8653 38.8001C35.272 38.8001 39.6549 34.3763 39.6549 28.9191C39.6549 23.462 35.272 19.0382 29.8653 19.0382C24.4587 19.0382 20.0757 23.462 20.0757 28.9191C20.0757 34.3763 24.4587 38.8001 29.8653 38.8001Z",
    fill: "#5571C6",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0583 57.3269V62.2675H12.6724V57.3269C12.6724 47.7238 20.3511 39.9425 29.8653 39.9425C34.6378 39.9425 38.9207 41.8879 42.0412 45.0374C42.4083 45.408 42.7448 45.7786 43.0507 46.18C45.2839 48.8663 46.7218 52.2321 46.9972 55.9374C47.0277 56.4006 47.0583 56.8638 47.0583 57.3269Z",
    fill: "#5571C6",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4487 37.4105C60.6895 37.4105 64.1275 33.9405 64.1275 29.6601C64.1275 25.3796 60.6895 21.9097 56.4487 21.9097C52.2079 21.9097 48.77 25.3796 48.77 29.6601C48.77 33.9405 52.2079 37.4105 56.4487 37.4105Z",
    fill: "#5571C6",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.94 52.0464V55.937H48.2194C47.9441 52.2317 46.5062 48.8659 44.2729 46.1796C46.445 41.5787 51.0645 38.3982 56.4488 38.3982C60.181 38.3982 63.5462 39.9112 65.9936 42.3815C68.4411 44.8518 69.94 48.2792 69.94 52.0464Z",
    fill: "#5571C6",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.45c3fd1159f9994939e4c8659283045b.svg";
export { ForwardRef as ReactComponent };